<template>
  <div class="section">
    <div class="container">
      <!-- Page Header -->
      <div class="mb-md">
        <div class="columns is-vcentered">
          <div class="column is-one-third">
            <breadcrumbs :history="[{ label: 'Settings', name: 'settings'}]" current="Assistant Q&A" />
          </div>
          <div class="column is-one-third">
            <h1 class="has-text-centered is-size-4">Assistant Q&amp;A</h1>
          </div>
        </div>
      </div>
      <div class="pb-lg mb-lg">
        <AssistantEntries />
      </div>
    </div>
  </div>
</template>

<script>
import AssistantEntries from '../components/Assistant/AssistantEntries'
export default {
  components: {
    AssistantEntries
  }
}
</script>
